import JEditableTable from '@/components/jeecg/JEditableTable'
import MtcLangModal from '@/components/mtcModule/mtcLangModal'
import { VALIDATE_NO_PASSED, getRefPromise, validateFormAndTables, validateTables } from '@/utils/JEditableTableUtil'
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { getLanguageField, resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export const mtcLangModalMixin = {
  components: {
    MtcLangModal
  },
  data() {
    return {
      title: '操作',
      visible: false,
      form: this.$form.createForm(this),
      confirmLoading: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      isEdit: false,
      mainLangItems: [], // 主表多语言字段
      subLangItems: {}, // 子表多语言字段
      langList: JSON.parse(this.$ls.get('languageList')), // 当前所有语言
      mainTableAllLangLists: [], // 列表带过来的多语言列表
      mainTableLangLists: {}, // 主表多语言数据结构，带输入值
      sysLanguageList: [], // 要提交的主表信息数组
      subTableLangLists: {} // 子表多语言数据结构，带输入值
    }
  },
  created() {
    this.$bus.$on('mtcLangOk', res => {
      let filedName = res.filedName
      let formData = res.formData
      this.setMainTableLangList(filedName, formData)
    })
  },
  mounted() {
    this.$bus.$on('mainlanguageLists', res => {
      this.mainTableAllLangLists = res
      // this.getLangItem()
    })
  },
  methods: {
    // 获取多语言字段 relEntityAttribute
    getLangItem() {
      this.mainTable && getLanguageField(this.mainTable).then(res => {
        this.mainLangItems = res.data
        this.mainTableLangLists = {}
        let mainTableLangLists = this.mainTableAllLangLists || []
        this.mainLangItems.forEach(item => {
          this.mainTableLangLists[ item.relEntityAttribute ] = []
        })
        for (let key in this.mainTableLangLists) {
          for (let i = 0; i < mainTableLangLists.length; i++) {
            if (key == mainTableLangLists[ i ].relEntityAttribute) {
              this.mainTableLangLists[ key ].push(mainTableLangLists[ i ])
            }
          }
        }
        console.log(this.mainLangItems, this.mainTableLangLists, '多语言返回值')
      })
    },
    // 获取弹框中主表的次语言pop数据
    getMainTablePop(relEntityAttribute) {
      let dataList = []
      let returnList = []
      if (!this.model[ relEntityAttribute ]) {
        return []
      }
      for (const key in this.mainTableLangLists) {
        if (key == relEntityAttribute) {
          dataList = this.mainTableLangLists[ key ]
        }
      }
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      dataList.length && dataList.map(item => {
        secondLanguage.length && secondLanguage.map(sItem => {
          if (sItem == item[ 'langType' ]) {
            returnList.push(item)
          }
        })
      })
      return returnList
    },
    // 判断是否是多语言输入框，是的话返回true（输入框只读）
    whetherLang(field) {
      if (this.mainLangItems && this.mainLangItems.length) {
        for (let i = 0; i < this.mainLangItems.length; i++) {
          if (this.mainLangItems[ i ].relEntityAttribute == field) {
            return true
          }
        }
      }
    },
    // 判断是否为多语言输入框，是的话触发弹窗
    isLangClick(field, require) {
      // console.log(this.model[field])
      if (this.model[ field ] == undefined && this.whetherLang(field)) {
        this.$bus.$emit('mtcLangDialog', { field: field, require: require, initialValue: [] })
        return false
      }
      // console.log('this.mainLangItems', this.mainLangItems)
      if (this.mainLangItems && this.mainLangItems.length) {
        for (let i = 0; i < this.mainLangItems.length; i++) {
          if (this.mainLangItems[ i ].relEntityAttribute == field) {
            /**
             * 触发弹窗
             * field 字段
             * require 是否必填
             * initialValue 初始化回显数据
             */
            this.$bus.$emit('mtcLangDialog', { field: field, require: require, initialValue: this.mainTableLangLists[ field ] })
            break
          }
        }
      }
    },
    /**
     * 输入完多语言，弹框关闭时触发，将值放入主表中，并渲染主Form
     * @param {String} filedName 多语言字段
     * @param {Object} formData 多语言输入值
     */
    setMainTableLangList(filedName, formData) {
      let mainTableItemLists = []
      for (let i = 0; i < this.mainLangItems.length; i++) {
        if (this.mainLangItems[ i ].relEntityAttribute == filedName) {
          for (const key in formData) {
            let mainLangItems = Object.assign({}, this.mainLangItems[ i ])
            this.mainTableLangLists[ filedName ] && this.mainTableLangLists[ filedName ].map(item => {
              if (item.langType == key) {
                mainLangItems.id = item.id
              }
            })
            // console.log('%c [ key ]', 'font-size:13px; background:pink; color:#bf2c9f;', key)
            // console.log('%c [ formData[key] ]', 'font-size:13px; background:pink; color:#bf2c9f;', formData[key])
            mainLangItems[ filedName ] = formData[ key ]
            mainLangItems.langText = formData[ key ]
            mainLangItems.langType = key
            mainTableItemLists.push(mainLangItems)
            if (key == this.$ls.get('language')) {
              // 插入数据
              this.model[ filedName ] = formData[ key ]
              let fieldval = pick(this.model, filedName)
              this.$nextTick(() => {
                this.form.setFieldsValue(fieldval)
              })
            }
          }
        }
      }
      // console.log('%c [ mainTableItemLists ]', 'font-size:13px; background:pink; color:#bf2c9f;', mainTableItemLists)
      this.mainTableLangLists[ filedName ] = mainTableItemLists
      console.log('%c [ this.mainTableLangLists ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.mainTableLangLists)
    },
    handleOk() {
      const that = this
      // console.log('this.mainTableLangLists', this.mainTableLangLists);
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let httpurl = ''
          let method = ''
          let formData = Object.assign(that.model, values)
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          if (!that.model.id) {
            httpurl += that.url.add
            method = 'post'
          } else {
            httpurl += that.url.edit
            method = 'put'
          }
          that.confirmLoading = true
          httpAction(httpurl, formData, method).then(res => {
            if (res.success) {
              that.$message.success(res.message)
              resetLangFieldMap()
              that.$emit('ok')
              that.close()
            } else {
              //错误之后 要放开禁用得
              that.model.code = null
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },
    setCompanyCode() {
    }
  }
}